import { useIsMobile } from 'hooks/useIsMobile';
import { Plus } from 'lucide-react';
import {
  handleOpenCreateThreadModal,
  handleOpenNewRelatedThreadModal,
} from 'modules/threads/utils';
import { Button } from 'components/ui/button';
import { IModalOptions } from 'modules/modals/types';

export interface ICreateNewThreadProps {
  open: (options: IModalOptions) => void;
  threadId?: string;
  name?: string;
  tags?: string[];
  isRelatedThread?: boolean;
}

export const NewThreadButton = ({
  open,
  name,
  tags,
  threadId,
  isRelatedThread,
}: ICreateNewThreadProps) => {
  const isMobile = useIsMobile();

  return (
    <Button
      size={isMobile ? 'sm' : 'default'}
      className="w-full lg:w-auto"
      onClick={
        !isRelatedThread
          ? () => handleOpenCreateThreadModal(open)
          : () => handleOpenNewRelatedThreadModal({ open, name, tags, threadId })
      }
      data-cy="dashboard-new-thread"
    >
      <Plus className="mr-2 h-4 w-4" />
      New Thread
    </Button>
  );
};
